import React from 'react';
import { Stack, Button, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import SharingOptions from './SharingOptions';

import logger from '../../../utils/logger';
const ButtonsContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  alignItems: 'center',
  gap: '12px',
  justifyContent: 'center',
  marginBottom: '20px',
  width: '100%',
  padding: '0 16px',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    gap: '16px',
    marginBottom: '24px',
    padding: '0 20px',
    flexWrap: 'wrap'
  },
  [theme.breakpoints.up('md')]: {
    gap: '20px',
    padding: 0
  }
}));

const SharingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginLeft: 0,
  width: '100%',
  justifyContent: 'center',
  marginTop: '8px',
  [theme.breakpoints.up('sm')]: {
    marginLeft: '20px',
    width: 'auto',
    marginTop: 0
  }
}));

const DownloadButton = styled(Button)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '15px',
  fontWeight: 600,
  textTransform: 'capitalize',
  color: '#ffffff',
  backgroundColor: '#EF232A',
  borderRadius: '8px',
  padding: '14px 32px',
  minWidth: '120px',
  width: '100%',
  maxWidth: '300px',
  minHeight: '48px',
  WebkitTapHighlightColor: 'transparent',
  transition: 'all 0.2s ease',
  '&:active': {
    transform: 'scale(0.98)',
    backgroundColor: '#D32F2F'
  },
  [theme.breakpoints.up('sm')]: {
    width: 'auto',
    maxWidth: 'none',
    fontSize: '14px',
    padding: '12px 32px',
    minHeight: '44px'
  },
  [theme.breakpoints.up('md')]: {
    '&:hover': {
      backgroundColor: '#D32F2F'
    },
    '&:active': {
      transform: 'none'
    }
  }
}));

const ShareButton = styled(Button)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '15px',
  fontWeight: 600,
  textTransform: 'capitalize',
  color: '#ffffff',
  backgroundColor: '#0B91D6',
  borderRadius: '8px',
  padding: '14px 32px',
  minWidth: '120px',
  width: '100%',
  maxWidth: '300px',
  minHeight: '48px',
  WebkitTapHighlightColor: 'transparent',
  transition: 'all 0.2s ease',
  '&:active': {
    transform: 'scale(0.98)',
    backgroundColor: '#0980C2'
  },
  [theme.breakpoints.up('sm')]: {
    width: 'auto',
    maxWidth: 'none',
    fontSize: '14px',
    padding: '12px 32px',
    minHeight: '44px'
  },
  [theme.breakpoints.up('md')]: {
    '&:hover': {
      backgroundColor: '#0980C2'
    },
    '&:active': {
      transform: 'none'
    }
  }
}));

const ActionButtons = ({ onDownload, onShare, showSharingOptions, sharingOptions, onSocialShare, onOpenScheduleModal }) => {
  const handleDownload = () => {
    logger.log('Download clicked');
    if (onDownload) {
      onDownload();
    }
  };

  const handleShare = () => {
    logger.log('Share clicked');
    if (onShare) {
      onShare();
    }
  };

  return (
    <ButtonsContainer>
      <DownloadButton variant="contained" onClick={handleDownload}>
        Download
      </DownloadButton>
      <ShareButton variant="contained" onClick={handleShare}>
        Share
      </ShareButton>
      
      {showSharingOptions && (
        <SharingContainer>
          <SharingOptions
            sharingOptions={sharingOptions}
            onSocialShare={onSocialShare}
            onOpenScheduleModal={onOpenScheduleModal}
          />
        </SharingContainer>
      )}
    </ButtonsContainer>
  );
};

export default ActionButtons;